<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>新增面经</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="formData.companyName"
            label="公司名称"
            :rules="[v => !!v || '请输入公司名称']"
            required
          ></v-text-field>

          <v-text-field
            v-model="formData.jobTitle"
            label="岗位名称"
            :rules="[v => !!v || '请输入岗位名称']"
            required
          ></v-text-field>

          <div class="mb-4">
            <label class="v-label theme--light">面试过程 <span class="red--text">*</span></label>
            <ckeditor
              :editor="editor"
              v-model="formData.experienceDetail"
              :config="editorConfig"
            ></ckeditor>
            <div v-if="!formData.experienceDetail" class="v-messages error--text">
              请输入面试过程
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn 
          color="primary" 
          text 
          @click="submit"
          :loading="saving"
          :disabled="!isValid"
        >
          储存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { interviewApi } from '@/api/interview'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'CreateInterviewExpPopup',
  
  components: {
    ckeditor: CKEditor.component
  },

  data() {
    return {
      dialog: false,
      valid: false,
      saving: false,
      editor: ClassicEditor,
      formData: {
        companyName: '',
        jobTitle: '',
        experienceDetail: ''
      },
      editorConfig: {
        toolbar: {
            shouldNotGroupWhenFull: true,
            items:['heading', '|',
          'bold', 'italic', 'link', '|',
          'bulletedList', 'numberedList', '|',
          'blockQuote', 
          'insertTable', '|',
          'undo', 
          'redo']
        },
        placeholder: '请输入面试过程...',
        removePlugins: []
      }
    }
  },

  computed: {
    isValid() {
      return this.formData.companyName && 
             this.formData.jobTitle && 
             this.formData.experienceDetail;
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.resetForm();
      });
    },

    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.formData = {
        companyName: '',
        jobTitle: '',
        experienceDetail: ''
      };
    },

    async submit() {
      if (!this.$refs.form.validate() || !this.formData.experienceDetail) return;

      this.saving = true;
      try {
        const response = await interviewApi.createInterviewExperience(this.formData);
        this.$emit('interview-exp-created', response.data);
        this.close();
        this.$toast.success('面经创建成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('创建失败：' + errorMessage);
      } finally {
        this.saving = false;
      }
    }
  }
}
</script> 